import { HiRefresh } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getReportSummary } from "../../redux/reports/reportsSlice";
import { useState } from "react";

const RefreshAllSummaries = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { branches } = useSelector((state) => state.branches);
  const [isClicked, setIsClicked] = useState(false);

  const refreshAll = () => {
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, 1000);
    branches.forEach((branch) => {
      dispatch(getReportSummary({ branchUrl: branch.ipAddress, force: true }));
    });
  };

  return (
    <button
      type="button"
      onClick={refreshAll}
      aria-label={t("common.refresh")}
      title={t("common.refresh")}
      className={`w-max h-max rounded-full text-xl bg-[--primary] hover:bg-[--primary-hover] p-[.2rem] cursor-pointer text-white flex items-center ${
        isClicked ? "rotate_360" : ""
      }`}
    >
      <HiRefresh aria-hidden="true" />
    </button>
  );
};

export default RefreshAllSummaries;
